import { z } from 'zod';

export const LocationFormSchema = z.object({
    name: z.string().nonempty({ message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }),
});

export type LocationFormInput = z.infer<typeof LocationFormSchema> & { area?: number | string | undefined };
